import "./App.css";

import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";


import DakshPage from "./component/DakshPage";


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<DakshPage />} />
      </Routes>
    </Router>
  );
}

export default App;
